function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { login as _login } from './auth.js';

var LoginForm = function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, LoginForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      email: '',
      password: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LoginForm.prototype.login = function login() {
    var _this2 = this;

    var _state = this.state,
        email = _state.email,
        password = _state.password;
    var _props = this.props,
        baseUrl = _props.baseUrl,
        onLogin = _props.onLogin,
        onLoading = _props.onLoading;


    if (!email || !password) return;

    onLoading && onLoading(true);
    this.setState({ error: null, loading: true });
    _login(baseUrl, email, password, function (err, token) {
      onLoading && onLoading(false);
      if (err) {
        _this2.setState({ loading: false, error: err, password: '' });
        return;
      }
      _this2.setState({ loading: false, email: '', password: '' });
      onLogin(token);
    });
  };

  LoginForm.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        loginText = _props2.loginText,
        errorText = _props2.errorText,
        emailText = _props2.emailText,
        passwordText = _props2.passwordText,
        showLabels = _props2.showLabels,
        children = _props2.children;
    var _state2 = this.state,
        email = _state2.email,
        password = _state2.password,
        error = _state2.error,
        loading = _state2.loading;


    return React.createElement(
      'form',
      { onSubmit: function onSubmit(e) {
          e.preventDefault();_this3.login();
        }, className: 'login-form' },
      error && React.createElement(
        'p',
        { className: 'login-form--error' },
        errorText
      ),
      React.createElement(
        'span',
        { className: 'login-form--control' },
        showLabels && React.createElement(
          'label',
          null,
          emailText
        ),
        React.createElement('input', {
          type: 'email',
          name: 'email',
          className: 'login-form--email',
          value: email,
          onChange: function onChange(e) {
            return _this3.setState({ email: e.target.value });
          },
          placeholder: showLabels ? '' : emailText
        })
      ),
      React.createElement(
        'span',
        { className: 'login-form--control' },
        showLabels && React.createElement(
          'label',
          null,
          passwordText
        ),
        React.createElement('input', {
          type: 'password',
          name: 'password',
          className: 'login-form--password',
          value: password,
          onChange: function onChange(e) {
            return _this3.setState({ password: e.target.value });
          },
          placeholder: showLabels ? '' : passwordText
        })
      ),
      React.createElement(
        'button',
        { type: 'submit', className: 'login-form--submit', disabled: loading },
        loginText
      ),
      React.createElement(
        'div',
        { className: 'login-form--children' },
        children
      )
    );
  };

  return LoginForm;
}(React.Component);

LoginForm.defaultProps = {
  loginText: 'Sign in',
  emailText: 'Email',
  passwordText: 'Password',
  showLabels: false,
  errorText: 'Login failed. Please check your email and password.'
};

LoginForm.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  onLogin: PropTypes.func.isRequired,
  loginText: PropTypes.string,
  errorText: PropTypes.string,
  showLabels: PropTypes.bool,
  baseUrl: PropTypes.string.isRequired,
  onLoading: PropTypes.func
} : {};

export default LoginForm;